import React, { Component } from "react";
import Slider from "react-slick";
import { Container } from "reactstrap";
import { FormattedMessage } from "react-intl";
import TinyJobCard from "../JobsPage/TinyJobCard";
import JobCard from "../JobsPage/JobCard";
import { handlePublicRequestError, Request } from '../../../helpers/request'
import LocaleLink from '../../Routes/LocaleLink'


class HomepageDreamJobs extends Component
{
    parallax = React.createRef()

    state = {
        offers: null
    };

    componentDidMount() {
        Request.get('job_orders/paginated?pagination=4')
            .then((data) => this.setState({ offers: data.data }))
            .catch(handlePublicRequestError);

        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.parallax.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(150 * delta - 80) + 'px'
    }

    settings = {
        dots: true,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false
                },
            },
        ]
    };

    render() {
        return (
            <section className="dream-job" ref={this.props.forwardedRef}>
                <div className="dream-job-after" ref={this.parallax}/>
                <Container>
                    <h2>
                        <FormattedMessage
                            id="portfolio.homepage.dream_job.title"
                            defaultMessage="LE JOB DE VOS RÊVES SE TROUVE ICI"
                        />
                    </h2>
                    <div className="dream-job-list">
                        {this.renderOffers()}
                        <div className="job-btn-wrap text-center">
                            <LocaleLink to="/jobs" className="btn btn-line-danger">
                                <FormattedMessage
                                    id="portfolio.homepage.dream_job.see_more"
                                    defaultMessage="Voir tous les jobs"
                                />
                            </LocaleLink>
                        </div>
                    </div>
                </Container>
            </section>
        )
    }

    renderOffers() {
        const {offers} = this.state;

        if (!offers) return null;

        return (
            <Slider className="dream-job-slider" {...this.settings}>
                {
                    offers.map((offer, key) => {
                        if (key === 3) return (<JobCard key={key} offer={offer} className={'job-info job-new d-block'}/>);
                        else return (<TinyJobCard key={key} offer={offer} className={'d-block job' + (key + 1)}/>);
                    })
                }
            </Slider>
        )
    }
}

export default HomepageDreamJobs;
